export default "__VITE_ASSET__mYFtRgY0__"